export async function initMenu() {
  document.querySelectorAll(".menu-item-has-children > a").forEach(function(element) {
    element.addEventListener('click', toggleMenu);
    element.addEventListener('touch', toggleMenu);
  });

  function toggleMenu(e) {
    const parent = this.parentNode;
    const menu = parent.querySelector(".sub-menu");

    if (!parent.classList.contains('expanded')) {
      parent.classList.add('expanded');
      menu.classList.add('no-animate');
      menu.style.height = 'auto';
      const height = menu.offsetHeight;
      menu.classList.remove('no-animate');
      menu.style.height = height + 'px';
    } else {
      parent.classList.remove('expanded');
      menu.style.height = 0;
    }

    //window.sidebar.updateSticky();
    //setTimeout(function () {
    //  window.sidebar.updateSticky();
    //}, 1000);

    e.preventDefault();
    return false;
  }

  if (document.querySelectorAll(".current-menu-parent").length) {
    document.body.classList.add('show-menu');

    document.querySelectorAll(".current-menu-parent ul").forEach(function(ul) {
      ul.style.height = ul.offsetHeight + 'px';
    });

    document.body.classList.remove('show-menu');
    document.querySelectorAll(".current-menu-parent").forEach(function(element) {
      element.classList.remove("current-menu-parent");
    });
  }

  document.querySelectorAll(".menu-toggle").forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      document.body.classList.toggle('show-menu');
    });
    toggle.addEventListener('touch', function() {
      document.body.classList.toggle('show-menu');
    });
  });
}
